export class Language {
    public static LANG_LOCAL_STORAGE_ITEM = 'rrps-lz-lang';
    public static STD_LANG_OBJ: Language = { iso: 'en', value: 'English' };
    iso: string;
    value: string;
}
